const capitalizeFirst = (s: string): string => {
  if (!s) return s;
  return s.charAt(0).toUpperCase() + s.slice(1);
};

export const translateEvent = (event: string, dictionary: Record<string, string>): string => {
  if (!event) return event;

  const sortedKeys = Object.keys(dictionary).sort((a, b) => b.length - a.length);

  let result = event;
  for (const key of sortedKeys) {
    const escaped = key.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    // \b only recognizes ASCII word characters, so it fails to find a boundary
    // next to Polish diacritics (e.g. "dogrywką", "drużyny") and silently skips
    // the match. Use Unicode-aware lookaround boundaries instead.
    const regex = new RegExp(`(?<![\\p{L}\\p{N}_])${escaped}(?![\\p{L}\\p{N}_])`, 'giu');
    result = result.replace(regex, dictionary[key]);
  }

  return capitalizeFirst(result);
};
